var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1296 9.00005C11.1296 9.32265 11.0065 9.6452 10.7606 9.89115L3.02097 17.6307C2.52863 18.1231 1.73039 18.1231 1.23825 17.6307C0.746106 17.1386 0.746106 16.3405 1.23825 15.8481L8.08674 9.00005L1.23848 2.15192C0.746345 1.65958 0.746345 0.861572 1.23848 0.369473C1.73062 -0.123106 2.52887 -0.123106 3.02121 0.369473L10.7609 8.10895C11.0068 8.35502 11.1296 8.67757 11.1296 9.00005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.3ba6529efd7e752529a1025da3164314.svg";
export { ForwardRef as ReactComponent };